import React from "react";
import LegalLayout from "@/components/legal/LegalLayout";

export default function Cookies() {
  return (
    <LegalLayout
      testId="cookies-page"
      kicker="Document N°03 · Cookies"
      title="Cookie Policy."
      updated="December 2025"
    >
      <p>
        This Cookie Policy explains how <strong>RTAMA LTD</strong>{" "}
        (registration number <strong>HE433506</strong>, registered office at
        Griva Digeni Avenue 51, Athineon Court, Office 202, 8047, Paphos,
        Cyprus) uses cookies and similar technologies on its website. By
        continuing to use the site, you consent to the use of cookies as
        described below.
      </p>

      <h2>1. What are cookies?</h2>
      <p>
        Cookies are small text files placed on your device when you visit a
        website. They are widely used to make websites work, improve user
        experience, and provide analytics to site owners.
      </p>

      <h2>2. Cookies we use</h2>

      <h3>Strictly necessary</h3>
      <p>
        Required for the website to function correctly (e.g., security,
        routing). These cannot be disabled.
      </p>

      <h3>Performance &amp; analytics</h3>
      <p>
        Help us understand how visitors interact with the website so we can
        improve it. These are anonymised wherever possible.
      </p>

      <h3>Functionality</h3>
      <p>Remember preferences such as language or region.</p>

      <h2>3. Third-party cookies</h2>
      <p>
        Some cookies may be set by trusted third parties such as analytics or
        embedded media providers. Their use is governed by their own privacy
        and cookie policies.
      </p>

      <h2>4. Managing cookies</h2>
      <p>
        You can manage or disable cookies via your browser settings. Note that
        disabling certain cookies may affect the functionality of the website.
        Useful links:
      </p>
      <ul>
        <li>
          <a
            href="https://support.google.com/chrome/answer/95647"
            target="_blank"
            rel="noopener noreferrer"
          >
            Google Chrome
          </a>
        </li>
        <li>
          <a
            href="https://support.mozilla.org/kb/cookies-information-websites-store-on-your-computer"
            target="_blank"
            rel="noopener noreferrer"
          >
            Mozilla Firefox
          </a>
        </li>
        <li>
          <a
            href="https://support.apple.com/guide/safari/manage-cookies-sfri11471"
            target="_blank"
            rel="noopener noreferrer"
          >
            Apple Safari
          </a>
        </li>
        <li>
          <a
            href="https://support.microsoft.com/microsoft-edge"
            target="_blank"
            rel="noopener noreferrer"
          >
            Microsoft Edge
          </a>
        </li>
      </ul>

      <h2>5. Updates</h2>
      <p>
        We may update this Cookie Policy as our website evolves. Material
        changes will be reflected via an updated &ldquo;Last updated&rdquo;
        date at the top of this page.
      </p>

      <h2>6. Contact</h2>
      <p>
        Questions about cookies? Email{" "}
        <a href="mailto:rtamaltd@gmail.com">rtamaltd@gmail.com</a>.
      </p>
    </LegalLayout>
  );
}
